<nav class="fixed bottom-0 left-0 right-0 z-50 flex h-14 items-stretch border-t border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-900">
  @for (item of tabItems; track item.id) {
    <a
      [routerLink]="item.link"
      routerLinkActive="!text-primary-600 dark:!text-primary-400"
      [routerLinkActiveOptions]="{ exact: false }"
      class="flex flex-1 flex-col items-center justify-center gap-0.5 py-1 text-gray-500 transition-colors dark:text-gray-400">
      <mat-icon class="icon-size-5 shrink-0" [svgIcon]="item.icon"></mat-icon>
      <span class="text-[10px] font-medium leading-tight">{{ item.title }}</span>
    </a>
  }
</nav>
